import moment from 'moment';
import { Link } from 'react-router-dom';

import BigList, { BigListItem } from '~/components/BigList';
import TrashcanIcon from '~/components/icons/TrashcanIcon';

import ConfirmDeleteDialog from './form/ConfirmDeleteDialog';
import styles from './ListForms.style';

class ListForms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeleteDialog: false,
      confirmDeleteDialogFormID: null,
      confirmDeleteDialogHasRecentResponse: null,
    };
  }

  confirmDelete = (form, event) => {
    event.preventDefault();
    this.setState({
      confirmDeleteDialog: true,
      confirmDeleteDialogFormID: form.id,
      confirmDeleteDialogHasRecentResponse: form.has_recent_response,
    });
  };

  onConfirmDelete = (value, formID) => {
    const { deleteForm } = this.props;
    if (value && formID) deleteForm(formID);
    this.setState({
      confirmDeleteDialog: false,
    });
  };

  renderActions = (form) => {
    const { classes } = this.props;
    let createdLabel = moment(form.created_at).format('MMM D, YYYY');

    return (
      <div className={classes.listMeta}>
        <div className={classes.listMetaCreated}>Created {createdLabel}</div>

        <div className={classes.listMetaCount}>{form.responses_count}</div>

        <div
          className={classes.listArchiveForm}
          onClick={(event) => {
            this.confirmDelete(form, event);
          }}>
          <TrashcanIcon className={classes.listArchiveFormIcon} />
        </div>
      </div>
    );
  };

  renderForm = (form) => {
    const { classes } = this.props;
    return (
      <Link to={`/forms/${form.id}`} key={form.id}>
        <BigListItem
          primary={form.name || 'Unknown form'}
          actions={this.renderActions(form)}
          classes={{ listItem: classes.listItem }}
        />
      </Link>
    );
  };

  render() {
    const { forms, loading, classes } = this.props;

    const {
      confirmDeleteDialog,
      confirmDeleteDialogFormID,
      confirmDeleteDialogHasRecentResponse,
    } = this.state;

    return (
      <div className={classes.root}>
        <BigList
          loading={loading}
          emptyBody="Time to create your first data-powered form!">
          {forms.map(this.renderForm)}
        </BigList>

        <ConfirmDeleteDialog
          open={confirmDeleteDialog}
          onClose={this.onConfirmDelete}
          formID={confirmDeleteDialogFormID}
          hasRecentResponse={confirmDeleteDialogHasRecentResponse}
        />
      </div>
    );
  }
}

ListForms.propTypes = {
  classes: PropTypes.object.isRequired,
  forms: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  createForm: PropTypes.func.isRequired,
};

export default withStyles(styles)(ListForms);
